import React from 'react'

import { Field } from 'formik'

import { H5,P } from '@driftt/tide-core'

import C from '../constants'
import CheckboxRow from '../form/CheckboxRow'
import SelectCheckboxRow from '../form/SelectCheckboxRow'

import styles from '../styles.module.css'

const SoundAndAppearanceSection: React.FC = () => (
  <section>
    <H5>Sound & appearance</H5>
    <P type="subtle">Choose how desktop notifications look, sound, and behave.</P>
    <Field name="properties.humane-notifications-browser-sound">
      {(props: any) => (
        <SelectCheckboxRow
          options={C.SOUND_OPTIONS}
          label="Play notification sounds on desktop"
          {...props}
        />
      )}
    </Field>
    <Field name="properties.no_notifications_without_tab_open">
      {(props: any) => (
        <CheckboxRow
          {...props}
          inverse
          content="Display desktop notifications when Drift is not open in a browser"
        />
      )}
    </Field>

    <Field name="properties.require-notification-interaction">
      {(props: any) => (
        <CheckboxRow
          {...props}
          content={
            <div>
              Keep desktop notifications on-screen until I interact with them
              <p className={styles.subtext}>Note: this feature is only available on the web app</p>
            </div>
          }
        />
      )}
    </Field>
  </section>
)

export default SoundAndAppearanceSection
